import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data"],
  _excluded2 = ["data"],
  _excluded3 = ["data"],
  _excluded4 = ["data"],
  _excluded5 = ["data"],
  _excluded6 = ["data"],
  _excluded7 = ["data"],
  _excluded8 = ["data"],
  _excluded9 = ["data"],
  _excluded10 = ["data"],
  _excluded11 = ["data"],
  _excluded12 = ["data"],
  _excluded13 = ["data"],
  _excluded14 = ["data"],
  _excluded15 = ["data"],
  _excluded16 = ["data"],
  _excluded17 = ["data"],
  _excluded18 = ["data"],
  _excluded19 = ["data"],
  _excluded20 = ["data"],
  _excluded21 = ["data"],
  _excluded22 = ["data"],
  _excluded23 = ["data"],
  _excluded24 = ["data"];
import { c as _c } from "react-compiler-runtime";
/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.universal.recording.review.be.rpc.UniversalRecordingReviewExternalRpc
 */

/* @bend-expect import-missing-runtime-dep */
import { useMemo } from 'react';
import { useQuery, useLazyQuery, useSuspenseQuery } from 'data-fetching-client';
import * as Queries from './UniversalRecordingReviewExternalRpc.dfc.new';
export function useValidateTokenQuery(options) {
  var _data2;
  const $ = _c(12);
  const t0 = useQuery(Queries.VALIDATE_TOKEN_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t = t0;
    ({
      data
    } = _t);
    rest = _objectWithoutPropertiesLoose(_t, _excluded);
    _t;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      validateToken: (_data = data) === null || _data === void 0 ? void 0 : _data.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data2 = data) === null || _data2 === void 0 ? void 0 : _data2.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useValidateTokenLazyQuery(options) {
  var _data4;
  const $ = _c(18);
  const [getter, t0] = useLazyQuery(Queries.VALIDATE_TOKEN_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t2 = t0;
    ({
      data
    } = _t2);
    rest = _objectWithoutPropertiesLoose(_t2, _excluded2);
    _t2;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data3;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      validateToken: (_data3 = data) === null || _data3 === void 0 ? void 0 : _data3.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== getter || $[10] !== t2) {
      t3 = [getter, t2];
      $[9] = getter;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = (_data4 = data) === null || _data4 === void 0 ? void 0 : _data4.result;
  let t3;
  if ($[12] !== rest || $[13] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== getter || $[16] !== t3) {
    t4 = [getter, t3];
    $[15] = getter;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export function useValidateTokenSuspenseQuery(options) {
  var _data5, _data8;
  const $ = _c(12);
  const t0 = useSuspenseQuery(Queries.VALIDATE_TOKEN_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t3 = t0;
    ({
      data
    } = _t3);
    rest = _objectWithoutPropertiesLoose(_t3, _excluded3);
    _t3;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== ((_data5 = data) === null || _data5 === void 0 ? void 0 : _data5.result) || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data6, _data7;
    t1 = options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      validateToken: (_data6 = data) === null || _data6 === void 0 ? void 0 : _data6.result
    } : undefined;
    $[3] = (_data7 = data) === null || _data7 === void 0 ? void 0 : _data7.result;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data8 = data) === null || _data8 === void 0 ? void 0 : _data8.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetEngagementDetailsQuery(options) {
  var _data10;
  const $ = _c(12);
  const t0 = useQuery(Queries.GET_ENGAGEMENT_DETAILS_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t4 = t0;
    ({
      data
    } = _t4);
    rest = _objectWithoutPropertiesLoose(_t4, _excluded4);
    _t4;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data9;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getEngagementDetails: (_data9 = data) === null || _data9 === void 0 ? void 0 : _data9.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data10 = data) === null || _data10 === void 0 ? void 0 : _data10.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetEngagementDetailsLazyQuery(options) {
  var _data12;
  const $ = _c(18);
  const [getter, t0] = useLazyQuery(Queries.GET_ENGAGEMENT_DETAILS_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t5 = t0;
    ({
      data
    } = _t5);
    rest = _objectWithoutPropertiesLoose(_t5, _excluded5);
    _t5;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data11;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getEngagementDetails: (_data11 = data) === null || _data11 === void 0 ? void 0 : _data11.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== getter || $[10] !== t2) {
      t3 = [getter, t2];
      $[9] = getter;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = (_data12 = data) === null || _data12 === void 0 ? void 0 : _data12.result;
  let t3;
  if ($[12] !== rest || $[13] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== getter || $[16] !== t3) {
    t4 = [getter, t3];
    $[15] = getter;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export function useGetEngagementDetailsSuspenseQuery(options) {
  var _data13, _data16;
  const $ = _c(12);
  const t0 = useSuspenseQuery(Queries.GET_ENGAGEMENT_DETAILS_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t6 = t0;
    ({
      data
    } = _t6);
    rest = _objectWithoutPropertiesLoose(_t6, _excluded6);
    _t6;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== ((_data13 = data) === null || _data13 === void 0 ? void 0 : _data13.result) || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data14, _data15;
    t1 = options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getEngagementDetails: (_data14 = data) === null || _data14 === void 0 ? void 0 : _data14.result
    } : undefined;
    $[3] = (_data15 = data) === null || _data15 === void 0 ? void 0 : _data15.result;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data16 = data) === null || _data16 === void 0 ? void 0 : _data16.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetNotesQuery(options) {
  var _data18;
  const $ = _c(12);
  const t0 = useQuery(Queries.GET_NOTES_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t7 = t0;
    ({
      data
    } = _t7);
    rest = _objectWithoutPropertiesLoose(_t7, _excluded7);
    _t7;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data17;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getNotes: (_data17 = data) === null || _data17 === void 0 ? void 0 : _data17.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data18 = data) === null || _data18 === void 0 ? void 0 : _data18.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetNotesLazyQuery(options) {
  var _data20;
  const $ = _c(18);
  const [getter, t0] = useLazyQuery(Queries.GET_NOTES_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t8 = t0;
    ({
      data
    } = _t8);
    rest = _objectWithoutPropertiesLoose(_t8, _excluded8);
    _t8;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data19;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getNotes: (_data19 = data) === null || _data19 === void 0 ? void 0 : _data19.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== getter || $[10] !== t2) {
      t3 = [getter, t2];
      $[9] = getter;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = (_data20 = data) === null || _data20 === void 0 ? void 0 : _data20.result;
  let t3;
  if ($[12] !== rest || $[13] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== getter || $[16] !== t3) {
    t4 = [getter, t3];
    $[15] = getter;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export function useGetNotesSuspenseQuery(options) {
  var _data21, _data24;
  const $ = _c(12);
  const t0 = useSuspenseQuery(Queries.GET_NOTES_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t9 = t0;
    ({
      data
    } = _t9);
    rest = _objectWithoutPropertiesLoose(_t9, _excluded9);
    _t9;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== ((_data21 = data) === null || _data21 === void 0 ? void 0 : _data21.result) || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data22, _data23;
    t1 = options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getNotes: (_data22 = data) === null || _data22 === void 0 ? void 0 : _data22.result
    } : undefined;
    $[3] = (_data23 = data) === null || _data23 === void 0 ? void 0 : _data23.result;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data24 = data) === null || _data24 === void 0 ? void 0 : _data24.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetRecordingQuery(options) {
  var _data26;
  const $ = _c(12);
  const t0 = useQuery(Queries.GET_RECORDING_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t10 = t0;
    ({
      data
    } = _t10);
    rest = _objectWithoutPropertiesLoose(_t10, _excluded10);
    _t10;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data25;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getRecording: (_data25 = data) === null || _data25 === void 0 ? void 0 : _data25.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data26 = data) === null || _data26 === void 0 ? void 0 : _data26.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetRecordingLazyQuery(options) {
  var _data28;
  const $ = _c(18);
  const [getter, t0] = useLazyQuery(Queries.GET_RECORDING_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t11 = t0;
    ({
      data
    } = _t11);
    rest = _objectWithoutPropertiesLoose(_t11, _excluded11);
    _t11;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data27;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getRecording: (_data27 = data) === null || _data27 === void 0 ? void 0 : _data27.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== getter || $[10] !== t2) {
      t3 = [getter, t2];
      $[9] = getter;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = (_data28 = data) === null || _data28 === void 0 ? void 0 : _data28.result;
  let t3;
  if ($[12] !== rest || $[13] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== getter || $[16] !== t3) {
    t4 = [getter, t3];
    $[15] = getter;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export function useGetRecordingSuspenseQuery(options) {
  var _data29, _data32;
  const $ = _c(12);
  const t0 = useSuspenseQuery(Queries.GET_RECORDING_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t12 = t0;
    ({
      data
    } = _t12);
    rest = _objectWithoutPropertiesLoose(_t12, _excluded12);
    _t12;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== ((_data29 = data) === null || _data29 === void 0 ? void 0 : _data29.result) || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data30, _data31;
    t1 = options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getRecording: (_data30 = data) === null || _data30 === void 0 ? void 0 : _data30.result
    } : undefined;
    $[3] = (_data31 = data) === null || _data31 === void 0 ? void 0 : _data31.result;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data32 = data) === null || _data32 === void 0 ? void 0 : _data32.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetTranscriptQuery(options) {
  var _data34;
  const $ = _c(12);
  const t0 = useQuery(Queries.GET_TRANSCRIPT_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t13 = t0;
    ({
      data
    } = _t13);
    rest = _objectWithoutPropertiesLoose(_t13, _excluded13);
    _t13;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data33;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getTranscript: (_data33 = data) === null || _data33 === void 0 ? void 0 : _data33.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data34 = data) === null || _data34 === void 0 ? void 0 : _data34.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetTranscriptLazyQuery(options) {
  var _data36;
  const $ = _c(18);
  const [getter, t0] = useLazyQuery(Queries.GET_TRANSCRIPT_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t14 = t0;
    ({
      data
    } = _t14);
    rest = _objectWithoutPropertiesLoose(_t14, _excluded14);
    _t14;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data35;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getTranscript: (_data35 = data) === null || _data35 === void 0 ? void 0 : _data35.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== getter || $[10] !== t2) {
      t3 = [getter, t2];
      $[9] = getter;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = (_data36 = data) === null || _data36 === void 0 ? void 0 : _data36.result;
  let t3;
  if ($[12] !== rest || $[13] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== getter || $[16] !== t3) {
    t4 = [getter, t3];
    $[15] = getter;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export function useGetTranscriptSuspenseQuery(options) {
  var _data37, _data40;
  const $ = _c(12);
  const t0 = useSuspenseQuery(Queries.GET_TRANSCRIPT_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t15 = t0;
    ({
      data
    } = _t15);
    rest = _objectWithoutPropertiesLoose(_t15, _excluded15);
    _t15;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== ((_data37 = data) === null || _data37 === void 0 ? void 0 : _data37.result) || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data38, _data39;
    t1 = options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getTranscript: (_data38 = data) === null || _data38 === void 0 ? void 0 : _data38.result
    } : undefined;
    $[3] = (_data39 = data) === null || _data39 === void 0 ? void 0 : _data39.result;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data40 = data) === null || _data40 === void 0 ? void 0 : _data40.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetSummaryQuery(options) {
  var _data42;
  const $ = _c(12);
  const t0 = useQuery(Queries.GET_SUMMARY_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t16 = t0;
    ({
      data
    } = _t16);
    rest = _objectWithoutPropertiesLoose(_t16, _excluded16);
    _t16;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data41;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getSummary: (_data41 = data) === null || _data41 === void 0 ? void 0 : _data41.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data42 = data) === null || _data42 === void 0 ? void 0 : _data42.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetSummaryLazyQuery(options) {
  var _data44;
  const $ = _c(18);
  const [getter, t0] = useLazyQuery(Queries.GET_SUMMARY_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t17 = t0;
    ({
      data
    } = _t17);
    rest = _objectWithoutPropertiesLoose(_t17, _excluded17);
    _t17;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data43;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getSummary: (_data43 = data) === null || _data43 === void 0 ? void 0 : _data43.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== getter || $[10] !== t2) {
      t3 = [getter, t2];
      $[9] = getter;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = (_data44 = data) === null || _data44 === void 0 ? void 0 : _data44.result;
  let t3;
  if ($[12] !== rest || $[13] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== getter || $[16] !== t3) {
    t4 = [getter, t3];
    $[15] = getter;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export function useGetSummarySuspenseQuery(options) {
  var _data45, _data48;
  const $ = _c(12);
  const t0 = useSuspenseQuery(Queries.GET_SUMMARY_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t18 = t0;
    ({
      data
    } = _t18);
    rest = _objectWithoutPropertiesLoose(_t18, _excluded18);
    _t18;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== ((_data45 = data) === null || _data45 === void 0 ? void 0 : _data45.result) || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data46, _data47;
    t1 = options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getSummary: (_data46 = data) === null || _data46 === void 0 ? void 0 : _data46.result
    } : undefined;
    $[3] = (_data47 = data) === null || _data47 === void 0 ? void 0 : _data47.result;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data48 = data) === null || _data48 === void 0 ? void 0 : _data48.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetActionItemsQuery(options) {
  var _data50;
  const $ = _c(12);
  const t0 = useQuery(Queries.GET_ACTION_ITEMS_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t19 = t0;
    ({
      data
    } = _t19);
    rest = _objectWithoutPropertiesLoose(_t19, _excluded19);
    _t19;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data49;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getActionItems: (_data49 = data) === null || _data49 === void 0 ? void 0 : _data49.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data50 = data) === null || _data50 === void 0 ? void 0 : _data50.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetActionItemsLazyQuery(options) {
  var _data52;
  const $ = _c(18);
  const [getter, t0] = useLazyQuery(Queries.GET_ACTION_ITEMS_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t20 = t0;
    ({
      data
    } = _t20);
    rest = _objectWithoutPropertiesLoose(_t20, _excluded20);
    _t20;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data51;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getActionItems: (_data51 = data) === null || _data51 === void 0 ? void 0 : _data51.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== getter || $[10] !== t2) {
      t3 = [getter, t2];
      $[9] = getter;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = (_data52 = data) === null || _data52 === void 0 ? void 0 : _data52.result;
  let t3;
  if ($[12] !== rest || $[13] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== getter || $[16] !== t3) {
    t4 = [getter, t3];
    $[15] = getter;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export function useGetActionItemsSuspenseQuery(options) {
  var _data53, _data56;
  const $ = _c(12);
  const t0 = useSuspenseQuery(Queries.GET_ACTION_ITEMS_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t21 = t0;
    ({
      data
    } = _t21);
    rest = _objectWithoutPropertiesLoose(_t21, _excluded21);
    _t21;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== ((_data53 = data) === null || _data53 === void 0 ? void 0 : _data53.result) || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data54, _data55;
    t1 = options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getActionItems: (_data54 = data) === null || _data54 === void 0 ? void 0 : _data54.result
    } : undefined;
    $[3] = (_data55 = data) === null || _data55 === void 0 ? void 0 : _data55.result;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data56 = data) === null || _data56 === void 0 ? void 0 : _data56.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetQAndAQuery(options) {
  var _data58;
  const $ = _c(12);
  const t0 = useQuery(Queries.GET_QAND_A_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t22 = t0;
    ({
      data
    } = _t22);
    rest = _objectWithoutPropertiesLoose(_t22, _excluded22);
    _t22;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data57;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getQAndA: (_data57 = data) === null || _data57 === void 0 ? void 0 : _data57.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data58 = data) === null || _data58 === void 0 ? void 0 : _data58.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function useGetQAndALazyQuery(options) {
  var _data60;
  const $ = _c(18);
  const [getter, t0] = useLazyQuery(Queries.GET_QAND_A_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t23 = t0;
    ({
      data
    } = _t23);
    rest = _objectWithoutPropertiesLoose(_t23, _excluded23);
    _t23;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== data || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data59;
    t1 = data && options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getQAndA: (_data59 = data) === null || _data59 === void 0 ? void 0 : _data59.result
    } : undefined;
    $[3] = data;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (data && options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    let t3;
    if ($[9] !== getter || $[10] !== t2) {
      t3 = [getter, t2];
      $[9] = getter;
      $[10] = t2;
      $[11] = t3;
    } else {
      t3 = $[11];
    }
    return t3;
  }
  const t2 = (_data60 = data) === null || _data60 === void 0 ? void 0 : _data60.result;
  let t3;
  if ($[12] !== rest || $[13] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[12] = rest;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== getter || $[16] !== t3) {
    t4 = [getter, t3];
    $[15] = getter;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  return t4;
}
export function useGetQAndASuspenseQuery(options) {
  var _data61, _data64;
  const $ = _c(12);
  const t0 = useSuspenseQuery(Queries.GET_QAND_A_QUERY, options);
  let data;
  let rest;
  if ($[0] !== t0) {
    var _t24 = t0;
    ({
      data
    } = _t24);
    rest = _objectWithoutPropertiesLoose(_t24, _excluded24);
    _t24;
    $[0] = t0;
    $[1] = data;
    $[2] = rest;
  } else {
    data = $[1];
    rest = $[2];
  }
  options === null || options === void 0 || options.useLegacyFieldNameMode;
  let t1;
  if ($[3] !== ((_data61 = data) === null || _data61 === void 0 ? void 0 : _data61.result) || $[4] !== (options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode)) {
    var _data62, _data63;
    t1 = options !== null && options !== void 0 && options.useLegacyFieldNameMode ? {
      getQAndA: (_data62 = data) === null || _data62 === void 0 ? void 0 : _data62.result
    } : undefined;
    $[3] = (_data63 = data) === null || _data63 === void 0 ? void 0 : _data63.result;
    $[4] = options === null || options === void 0 ? void 0 : options.useLegacyFieldNameMode;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const legacyFormatData = t1;
  if (options !== null && options !== void 0 && options.useLegacyFieldNameMode) {
    let t2;
    if ($[6] !== legacyFormatData || $[7] !== rest) {
      t2 = Object.assign({
        data: legacyFormatData
      }, rest);
      $[6] = legacyFormatData;
      $[7] = rest;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    return t2;
  }
  const t2 = (_data64 = data) === null || _data64 === void 0 ? void 0 : _data64.result;
  let t3;
  if ($[9] !== rest || $[10] !== t2) {
    t3 = Object.assign({
      data: t2
    }, rest);
    $[9] = rest;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}